module.exports = __webpack_public_path__ + "static/media/fourteen.7f8846d4.jpg";